import * as React from "react";
import {
  TextField,
  BooleanField,
  ImageField,
  Show,
  NumberField,
  usePermissions,
  useRecordContext,
  Title,
} from "react-admin";
import { ROLE_TYPES } from "../enums/Roles";
import { SimpleShowLayout } from "../common/SimpleShowLayout";

const DistrictTitle = () => {
  const record = useRecordContext();
  return <Title title={`Barrio "${record?.name}"`} />;
};

const DistrictShow = () => {
  const { permissions } = usePermissions();
  return (
    <Show title={<DistrictTitle />}>
      <SimpleShowLayout>
        {permissions === ROLE_TYPES.ADMIN && (
          <TextField source="id" label="ID" />
        )}
        <TextField source="name" label="Nombre" />
        <TextField source="originalName" label="Nombre Original" />
        <ImageField source="image" label="Imagen" />
        <TextField source="location[1]" label="Latitud" />
        <TextField source="location[0]" label="Longitud" />

        {/* Google Maps fields */}
        <NumberField source="locality" label="Localidad" />
        <NumberField source="state" label="Estado" />
        <NumberField source="county" label="Condado" />
        <NumberField source="country" label="País" />
        <NumberField source="postalCode" label="Código Postal" />

        <NumberField source="order" label="Orden" />
        <BooleanField source="visible" label="Visible" />
        <BooleanField source="active" label="Activo" />
      </SimpleShowLayout>
    </Show>
  );
};

export default DistrictShow;
